module.exports = __webpack_public_path__ + "img/paper4.41112d23.png";